export const REACT_APP_ENV: 'development' | 'production' | 'dev' = 'production';
export const REACT_APP_GA_TOKEN = 'UA-156519954-2';
export const REACT_APP_API_HOST = 'https://api.barboxx.io/v1';
export const REACT_APP_WEBSOCKET_HOST = 'https://api.barboxx.io';
export const REACT_APP_ORIGIN = 'https://admin.barboxx.io';
export const REACT_APP_GOOGLE_MAPS_API_KEY =
    'AIzaSyCkyyHjhnrBPqawFBxDQERf_JR8XezutY0';
export const REACT_APP_STRIPE_PUBLISHABLE_KEY =
    'pk_live_51MLqp7Do3erQF6JVlSwiUTbT7MIYoxa4c6XleTNNcBhv2wGnH0JsAWFHctntQnzp5mynrY5luuC7rjHxnvZM8G9J00N3XjIG2X';
export const REACT_APP_IMAGE_KIT_PUBLIC_KEY =
    'public_6uTwQhx/5OJ5kiJsFRNYfkbpuD8=';
export const REACT_APP_IMAGE_KIT_URL_ENDPOINT =
    'https://ik.imagekit.io/barboxx';
